import { jsx as r } from "react/jsx-runtime";
import { C as D, E as G, K, f as L, F as M, G as N } from "../../vendor--aJiswR_.js";
import { forwardRef as R, useState as T, useEffect as V, Fragment as k } from "react";
import { getSpacingClasses as q } from "../../utils/getSpacingClasses/index.js";
import { loadIcon as z } from "./loadIcon/index.js";
import '../../assets/index26.css';const A = "_xs_oe7v6_1", J = "_sm_oe7v6_5", O = "_md_oe7v6_9", Q = "_lg_oe7v6_13", U = "_xl_oe7v6_17", X = "_moon_oe7v6_21", Y = "_red_oe7v6_25", Z = "_sienna_oe7v6_29", ee = "_gold_oe7v6_33", oe = "_cactus_oe7v6_37", se = "_green_oe7v6_41", te = "_teal_oe7v6_45", ne = "_blue_oe7v6_49", ce = "_purple_oe7v6_53", ae = "_magenta_oe7v6_57", re = "_baseIcon_oe7v6_61", _e = "_color_oe7v6_76", t = {
  xs: A,
  sm: J,
  md: O,
  lg: Q,
  xl: U,
  moon: X,
  red: Y,
  sienna: Z,
  gold: ee,
  cactus: oe,
  green: se,
  teal: te,
  blue: ne,
  purple: ce,
  magenta: ae,
  baseIcon: re,
  color: _e
}, pe = R(
  ({
    id: _,
    m: d,
    mt: l,
    mr: i,
    mb: f,
    ml: v,
    p: m,
    pt: p,
    pr: b,
    pb: u,
    pl: g,
    icon: e,
    description: c,
    color: a,
    size: $ = "md",
    className: x,
    ...o
  }, I) => {
    const [h, F] = T(""), P = D(_), s = !!c, { focusProps: C, isFocused: S, isFocusVisible: y } = G(o), { hoverProps: B, isHovered: E } = K(o);
    V(() => {
      z(e).then((n = "") => {
        F(n);
      }).catch((n) => {
        console.error(`Failed to load icon "${e}":`, n);
      });
    }, [e]);
    const H = L(
      t.baseIcon,
      t[$],
      {
        ...a && { [t[a]]: !0, [t.color]: !0 },
        ...q({ m: d, mt: l, mr: i, mb: f, ml: v, p: m, pt: p, pr: b, pb: u, pl: g })
      },
      x
    ), W = s ? { role: "img", "aria-label": c } : { role: "presentation", "aria-hidden": !0 }, j = s ? {
      "data-focus-visible": y || void 0,
      "data-focused": S || void 0,
      "data-hovered": E || void 0
    } : {}, w = s ? M(o, B, C) : o;
    return /* @__PURE__ */ r(s ? N : k, { children: /* @__PURE__ */ r(
      "span",
      {
        ...w,
        ...W,
        ...j,
        style: void 0,
        id: P,
        ref: I,
        "data-icon": e,
        className: H,
        dangerouslySetInnerHTML: { __html: h }
      }
    ) });
  }
);
export {
  pe as BaseIcon
};
//# sourceMappingURL=index.js.map
